// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BankDetailsForm_modalOverlay__YfBuS {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.BankDetailsForm_modal__rNz8P {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  animation: BankDetailsForm_slideIn__hiPg3 0.3s ease-out;
}

@keyframes BankDetailsForm_slideIn__hiPg3 {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.BankDetailsForm_modalHeader__EMOFt {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 8px 8px 0 0;
}
.BankDetailsForm_modalHeader__EMOFt h2 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
}

.BankDetailsForm_closeButton__R4jWD {
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}
.BankDetailsForm_closeButton__R4jWD:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.BankDetailsForm_form__5Pj0P {
  padding: 24px;
}

.BankDetailsForm_tableContainer__YWUrY {
  margin-bottom: 20px;
  overflow-x: auto;
}

.BankDetailsForm_formTable__-ZqAo {
  border-collapse: collapse;
  width: 100%;
  text-align: left;
  font-family: Arial, sans-serif;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.BankDetailsForm_formTable__-ZqAo table, .BankDetailsForm_formTable__-ZqAo th, .BankDetailsForm_formTable__-ZqAo td {
  border: 1px solid #333;
}
.BankDetailsForm_formTable__-ZqAo th, .BankDetailsForm_formTable__-ZqAo td {
  padding: 8px;
  vertical-align: middle;
  border: 1px solid #333;
}
.BankDetailsForm_formTable__-ZqAo .BankDetailsForm_centerHeader__OSji- {
  text-align: center;
  font-weight: bold;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-size: 1.1rem;
  padding: 12px 8px;
}
.BankDetailsForm_formTable__-ZqAo th {
  background-color: #f5f5f5;
  font-weight: bold;
  text-align: center;
  border: 1px solid #333;
}
.BankDetailsForm_formTable__-ZqAo td {
  border: 1px solid #333;
}
.BankDetailsForm_formTable__-ZqAo td:first-child {
  text-align: center;
  font-weight: bold;
  background-color: #f9f9f9;
}
.BankDetailsForm_formTable__-ZqAo input {
  width: 100%;
  border: none;
  outline: none;
  padding: 6px 8px;
  font-size: 14px;
  background: transparent;
  transition: background-color 0.2s;
}
.BankDetailsForm_formTable__-ZqAo input:focus {
  background-color: #f0f8ff;
}
.BankDetailsForm_formTable__-ZqAo input::placeholder {
  color: #999;
  font-style: italic;
}
.BankDetailsForm_formTable__-ZqAo tr:nth-child(even) {
  background-color: #fafafa;
}
.BankDetailsForm_formTable__-ZqAo tr:hover {
  background-color: #f0f0f0;
}

.BankDetailsForm_note__rTMMQ {
  margin: 20px 0;
  padding: 15px;
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 6px;
  color: #856404;
}
.BankDetailsForm_note__rTMMQ p {
  margin: 0;
  font-size: 14px;
  line-height: 1.4;
}

.BankDetailsForm_error__IJt2e {
  background-color: #f8d7da;
  color: #721c24;
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 16px;
  border: 1px solid #f5c6cb;
  font-size: 14px;
}

.BankDetailsForm_success__tUHQe {
  background-color: #d4edda;
  color: #155724;
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 16px;
  border: 1px solid #c3e6cb;
  font-size: 14px;
}

.BankDetailsForm_formActions__PTC8K {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
}

.BankDetailsForm_cancelButton__Dh7Qf {
  padding: 10px 20px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
}
.BankDetailsForm_cancelButton__Dh7Qf:hover:not(:disabled) {
  background-color: #f5f5f5;
  border-color: #ccc;
}
.BankDetailsForm_cancelButton__Dh7Qf:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.BankDetailsForm_submitButton__UKz4t {
  padding: 10px 24px;
  border: none;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s;
}
.BankDetailsForm_submitButton__UKz4t:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}
.BankDetailsForm_submitButton__UKz4t:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.BankDetailsForm_addRowCell__mjWV7 {
  text-align: center;
  padding: 12px 8px;
  background-color: #f8f9fa;
  border: 1px solid #333;
}

.BankDetailsForm_addRowButton__cSkBg {
  padding: 8px 16px;
  border: 2px dashed #667eea;
  background: white;
  color: #667eea;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  width: 100%;
  max-width: 200px;
}
.BankDetailsForm_addRowButton__cSkBg:hover {
  background-color: #667eea;
  color: white;
  border-color: #667eea;
  transform: translateY(-1px);
}

.BankDetailsForm_removeButton__5IzQg {
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}
.BankDetailsForm_removeButton__5IzQg:hover {
  background-color: #c82333;
  transform: scale(1.1);
}

@media (max-width: 768px) {
  .BankDetailsForm_modal__rNz8P {
    margin: 10px;
    max-width: calc(100vw - 20px);
  }
  .BankDetailsForm_modalHeader__EMOFt {
    padding: 16px 20px;
  }
  .BankDetailsForm_modalHeader__EMOFt h2 {
    font-size: 1.3rem;
  }
  .BankDetailsForm_form__5Pj0P {
    padding: 16px;
  }
  .BankDetailsForm_formTable__-ZqAo {
    font-size: 12px;
  }
  .BankDetailsForm_formTable__-ZqAo th, .BankDetailsForm_formTable__-ZqAo td {
    padding: 6px;
  }
  .BankDetailsForm_formTable__-ZqAo input {
    font-size: 12px;
    padding: 4px 6px;
  }
  .BankDetailsForm_formActions__PTC8K {
    flex-direction: column;
    gap: 8px;
  }
  .BankDetailsForm_formActions__PTC8K button {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .BankDetailsForm_formTable__-ZqAo {
    font-size: 11px;
  }
  .BankDetailsForm_formTable__-ZqAo th, .BankDetailsForm_formTable__-ZqAo td {
    padding: 4px;
  }
  .BankDetailsForm_formTable__-ZqAo .BankDetailsForm_centerHeader__OSji- {
    font-size: 1rem;
    padding: 8px 4px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/bank-details/BankDetailsForm.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,uDAAA;AACF;;AAEA;EACE;IACE,UAAA;IACA,4BAAA;EACF;EACA;IACE,UAAA;IACA,wBAAA;EACF;AACF;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;EACA,6DAAA;EACA,YAAA;EACA,0BAAA;AAAF;AAEE;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;AAAJ;;AAIA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iCAAA;AADF;AAGE;EACE,0CAAA;AADJ;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,mBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,8BAAA;EACA,iBAAA;EACA,wCAAA;AAFF;AAIE;EACE,sBAAA;AAFJ;AAKE;EACE,YAAA;EACA,sBAAA;EACA,sBAAA;AAHJ;AAME;EACE,kBAAA;EACA,iBAAA;EACA,6DAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AAJJ;AAOE;EACE,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AALJ;AAQE;EACE,sBAAA;AANJ;AAQI;EACE,kBAAA;EACA,iBAAA;EACA,yBAAA;AANN;AAUE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,iCAAA;AARJ;AAUI;EACE,yBAAA;AARN;AAWI;EACE,WAAA;EACA,kBAAA;AATN;AAaE;EACE,yBAAA;AAXJ;AAcE;EACE,yBAAA;AAZJ;;AAgBA;EACE,cAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAbF;AAeE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AAbJ;;AAiBA;EACE,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAdF;;AAiBA;EACE,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAdF;;AAiBA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AAdF;AAgBE;EACE,yBAAA;EACA,kBAAA;AAdJ;AAiBE;EACE,YAAA;EACA,mBAAA;AAfJ;;AAmBA;EACE,kBAAA;EACA,YAAA;EACA,6DAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AAhBF;AAkBE;EACE,2BAAA;EACA,+CAAA;AAhBJ;AAmBE;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AAjBJ;;AAqBA;EACE,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;AAlBF;;AAqBA;EACE,iBAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;AAlBF;AAoBE;EACE,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,2BAAA;AAlBJ;;AAsBA;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AAnBF;AAqBE;EACE,yBAAA;EACA,qBAAA;AAnBJ;;AAwBA;EACE;IACE,YAAA;IACA,6BAAA;EArBF;EAwBA;IACE,kBAAA;EAtBF;EAwBE;IACE,iBAAA;EAtBJ;EA0BA;IACE,aAAA;EAxBF;EA2BA;IACE,eAAA;EAzBF;EA2BE;IACE,YAAA;EAzBJ;EA4BE;IACE,eAAA;IACA,gBAAA;EA1BJ;EA8BA;IACE,sBAAA;IACA,QAAA;EA5BF;EA8BE;IACE,WAAA;EA5BJ;AACF;AAgCA;EACE;IACE,eAAA;EA9BF;EAgCE;IACE,YAAA;EA9BJ;EAiCE;IACE,eAAA;IACA,gBAAA;EA/BJ;AACF","sourcesContent":[".modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modal {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  max-width: 900px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.modalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e0e0e0;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-radius: 8px 8px 0 0;\n\n  h2 {\n    margin: 0;\n    font-size: 1.5rem;\n    font-weight: 600;\n  }\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background-color 0.2s;\n\n  &:hover {\n    background-color: rgba(255, 255, 255, 0.2);\n  }\n}\n\n.form {\n  padding: 24px;\n}\n\n.tableContainer {\n  margin-bottom: 20px;\n  overflow-x: auto;\n}\n\n.formTable {\n  border-collapse: collapse;\n  width: 100%;\n  text-align: left;\n  font-family: Arial, sans-serif;\n  background: white;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n\n  table, th, td {\n    border: 1px solid #333;\n  }\n\n  th, td {\n    padding: 8px;\n    vertical-align: middle;\n    border: 1px solid #333;\n  }\n\n  .centerHeader {\n    text-align: center;\n    font-weight: bold;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    font-size: 1.1rem;\n    padding: 12px 8px;\n  }\n\n  th {\n    background-color: #f5f5f5;\n    font-weight: bold;\n    text-align: center;\n    border: 1px solid #333;\n  }\n\n  td {\n    border: 1px solid #333;\n    \n    &:first-child {\n      text-align: center;\n      font-weight: bold;\n      background-color: #f9f9f9;\n    }\n  }\n\n  input {\n    width: 100%;\n    border: none;\n    outline: none;\n    padding: 6px 8px;\n    font-size: 14px;\n    background: transparent;\n    transition: background-color 0.2s;\n\n    &:focus {\n      background-color: #f0f8ff;\n    }\n\n    &::placeholder {\n      color: #999;\n      font-style: italic;\n    }\n  }\n\n  tr:nth-child(even) {\n    background-color: #fafafa;\n  }\n\n  tr:hover {\n    background-color: #f0f0f0;\n  }\n}\n\n.note {\n  margin: 20px 0;\n  padding: 15px;\n  background-color: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 6px;\n  color: #856404;\n\n  p {\n    margin: 0;\n    font-size: 14px;\n    line-height: 1.4;\n  }\n}\n\n.error {\n  background-color: #f8d7da;\n  color: #721c24;\n  padding: 12px 16px;\n  border-radius: 6px;\n  margin-bottom: 16px;\n  border: 1px solid #f5c6cb;\n  font-size: 14px;\n}\n\n.success {\n  background-color: #d4edda;\n  color: #155724;\n  padding: 12px 16px;\n  border-radius: 6px;\n  margin-bottom: 16px;\n  border: 1px solid #c3e6cb;\n  font-size: 14px;\n}\n\n.formActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.cancelButton {\n  padding: 10px 20px;\n  border: 1px solid #ddd;\n  background: white;\n  color: #666;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n\n  &:hover:not(:disabled) {\n    background-color: #f5f5f5;\n    border-color: #ccc;\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.submitButton {\n  padding: 10px 24px;\n  border: none;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.2s;\n\n  &:hover:not(:disabled) {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n  }\n\n  &:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n    transform: none;\n  }\n}\n\n.addRowCell {\n  text-align: center;\n  padding: 12px 8px;\n  background-color: #f8f9fa;\n  border: 1px solid #333;\n}\n\n.addRowButton {\n  padding: 8px 16px;\n  border: 2px dashed #667eea;\n  background: white;\n  color: #667eea;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n  width: 100%;\n  max-width: 200px;\n\n  &:hover {\n    background-color: #667eea;\n    color: white;\n    border-color: #667eea;\n    transform: translateY(-1px);\n  }\n}\n\n.removeButton {\n  background: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n\n  &:hover {\n    background-color: #c82333;\n    transform: scale(1.1);\n  }\n}\n\n// Responsive design\n@media (max-width: 768px) {\n  .modal {\n    margin: 10px;\n    max-width: calc(100vw - 20px);\n  }\n\n  .modalHeader {\n    padding: 16px 20px;\n\n    h2 {\n      font-size: 1.3rem;\n    }\n  }\n\n  .form {\n    padding: 16px;\n  }\n\n  .formTable {\n    font-size: 12px;\n\n    th, td {\n      padding: 6px;\n    }\n\n    input {\n      font-size: 12px;\n      padding: 4px 6px;\n    }\n  }\n\n  .formActions {\n    flex-direction: column;\n    gap: 8px;\n\n    button {\n      width: 100%;\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .formTable {\n    font-size: 11px;\n\n    th, td {\n      padding: 4px;\n    }\n\n    .centerHeader {\n      font-size: 1rem;\n      padding: 8px 4px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `BankDetailsForm_modalOverlay__YfBuS`,
	"modal": `BankDetailsForm_modal__rNz8P`,
	"slideIn": `BankDetailsForm_slideIn__hiPg3`,
	"modalHeader": `BankDetailsForm_modalHeader__EMOFt`,
	"closeButton": `BankDetailsForm_closeButton__R4jWD`,
	"form": `BankDetailsForm_form__5Pj0P`,
	"tableContainer": `BankDetailsForm_tableContainer__YWUrY`,
	"formTable": `BankDetailsForm_formTable__-ZqAo`,
	"centerHeader": `BankDetailsForm_centerHeader__OSji-`,
	"note": `BankDetailsForm_note__rTMMQ`,
	"error": `BankDetailsForm_error__IJt2e`,
	"success": `BankDetailsForm_success__tUHQe`,
	"formActions": `BankDetailsForm_formActions__PTC8K`,
	"cancelButton": `BankDetailsForm_cancelButton__Dh7Qf`,
	"submitButton": `BankDetailsForm_submitButton__UKz4t`,
	"addRowCell": `BankDetailsForm_addRowCell__mjWV7`,
	"addRowButton": `BankDetailsForm_addRowButton__cSkBg`,
	"removeButton": `BankDetailsForm_removeButton__5IzQg`
};
export default ___CSS_LOADER_EXPORT___;
